export default '/src/assets/webgl/francesca_2/audios/en/bundle_1.mp3'